var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifyFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9l2 2 4-4",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4h12",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 12,
    height: 13,
    rx: 0.8,
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgOUw3LjAwMDAxIDExTDExIDciIHN0cm9rZT0iIzdEODA4NSIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIgNEgxNCIgc3Ryb2tlPSIjN0Q4MDg1IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8cmVjdCB4PSIyIiB5PSIxLjUiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMyIgcng9IjAuOCIgc3Ryb2tlPSIjN0Q4MDg1IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8L3N2Zz4K";
export { SvgVerifyFolder as ReactComponent };